import { useCallback, useState } from "react";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useAddSubscriptionAdminMutation } from "../../../services/resourceGroups/subscriptionApi";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { validateEmail } from "../../../utils/utils";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { FormattedMessage, useIntl } from "react-intl";

function AddAdminDialog(props: { subscriptionId: string; isOpen: boolean; setIsOpen: any }) {
  const intl = useIntl();
  const { subscriptionId, isOpen, setIsOpen } = props;
  const [add, addResult] = useAddSubscriptionAdminMutation();
  useReportMutationState(addResult, () => close());
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  const [isNameValid, setIsNameValid] = useState<boolean>(false);
  const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
  const inputsValid = isNameValid && isEmailValid;

  const close = () => setIsOpen(false);

  const handleNameChanged = useCallback(
    (newName: string) => {
      setName(newName);
      setIsNameValid(newName !== undefined && newName.length > 3);
    },
    [setName, setIsNameValid]
  );

  const handleMailChanged = useCallback(
    (newmail: string) => {
      setEmail(newmail);
      setIsEmailValid(validateEmail(newmail) !== null);
    },
    [setEmail, setIsEmailValid]
  );

  const handleSubmit = async () => {
    add({
      subscriptionId: subscriptionId,
      displayName: name,
      email: email,
    });
  };

  return (
    <>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>
          <FormattedMessage id={"addAdminHeader"} defaultMessage={"Add Administrator"} />
        </ModalHeader>
        <ModalBody>
          <FormControl
            label={() => intl.formatMessage({ id: "email", defaultMessage: "E-Mail" })}
            caption={() =>
              intl.formatMessage({
                id: "emailInputDescr",
                defaultMessage: "Enter the users e-mail",
              })
            }
            error={!isEmailValid}>
            <>
              <Input
                value={email}
                onChange={(e) => {
                  handleMailChanged(e.target.value);
                }}
                placeholder="someone@factory-ag.com"
                clearable
                clearOnEscape
              />
            </>
          </FormControl>
          <FormControl
            label={() =>
              intl.formatMessage({
                id: "displayName",
                defaultMessage: "Display Name",
              })
            }
            caption={() =>
              intl.formatMessage({
                id: "displayNameInputDescr",
                defaultMessage: "Enter a descriptive Username to display",
              })
            }
            error={!isNameValid}>
            <>
              <Input
                value={name}
                onChange={(e) => {
                  handleNameChanged(e.target.value);
                }}
                placeholder="Max Mustermann"
                clearable
                clearOnEscape
              />
            </>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            <FormattedMessage id={"cancel"} defaultMessage={"Cancel"} />
          </ModalButton>
          <ModalButton disabled={!inputsValid} isLoading={addResult.isLoading} onClick={handleSubmit}>
            <FormattedMessage id={"ok"} defaultMessage={"Ok"} />
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default AddAdminDialog;
